import React from 'react';
import PropTypes from 'prop-types';

/**
 * Text Atom - podstawowy komponent tekstu
 */
const Text = ({ 
  as = 'p',
  size = 'base',
  weight = 'normal',
  color = 'default',
  children, 
  className = '',
  ...props 
}) => {
  const Tag = as;
  
  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm', 
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  const weightClasses = {
    light: 'font-light',
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold'
  };

  const colorClasses = {
    default: 'text-gray-900',
    muted: 'text-gray-600',
    subtle: 'text-gray-500',
    primary: 'text-primary-600',
    success: 'text-green-600',
    warning: 'text-yellow-600',
    error: 'text-red-600'
  };

  const classes = [
    sizeClasses[size],
    weightClasses[weight],
    colorClasses[color],
    className
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
};

Text.displayName = 'Text';

Text.propTypes = {
  as: PropTypes.oneOf(['p', 'span', 'div', 'label']),
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl']),
  weight: PropTypes.oneOf(['light', 'normal', 'medium', 'semibold', 'bold']),
  color: PropTypes.oneOf(['default', 'muted', 'subtle', 'primary', 'success', 'warning', 'error']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Text;
